// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearchInterestTags-cls1_UjV","cls2":"ResearchInterestTags-cls2_57c ResearchInterestTags-cls1_UjV"};